<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { breadcrumbType} = props.content?.data

</script>
<template>
  <section>
      <LayoutBreadcrumbs />
  </section>
</template>
